import DropdownSelect from 'components/commons/DropdownSelect';
import { Stack, Typography } from '@mui/material';
import RangeCreatableSelect from 'components/commons/RangeCreatableSelect';
import PropTypes from 'prop-types';

const RpRangeAutocomplete = function({isDropdown = true, ...props}) {
    const content = (
        <>
            <Stack spacing={2} mb={0.5}>
                <Typography variant="text1" gutterBottom>{props.label}</Typography>
            </Stack>
            {props.children}
            <Stack spacing={2} mb={1}>
                <Typography variant="subtitle1" gutterBottom>{props.subLabel}</Typography>
            </Stack>
            <RangeCreatableSelect
                minOptions={props.minOptions}
                maxOptions={props.maxOptions}
                minValue={props.minValue}
                maxValue={props.maxValue}
                onChange={props.onChange}
                formatter={props.formatter}
                validateInput={props.validateInput}
                onError={props.onError}
                sx={!isDropdown ? { width: '100%' } : null}
                maxInputLength={props.maxInputLength}
                dropdownDisplayFormatter={props.dropdownDisplayFormatter}
            />
        </>
    );
    return isDropdown ? (
        <DropdownSelect
            label={props.label}
            value={props.value}
            width={props.width || 140}
            active={props.active}
            error={props.error}
            showValueAsTooltip={props.showValueAsTooltip}
        >
            {content}
        </DropdownSelect>
    ) : content;
};

RpRangeAutocomplete.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    active: PropTypes.bool,
    error: PropTypes.bool,
    showValueAsTooltip: PropTypes.bool,
    subLabel: PropTypes.string,
    minOptions: PropTypes.array.isRequired,
    maxOptions: PropTypes.array.isRequired,
    minValue: PropTypes.object.isRequired,
    maxValue: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    formatter: PropTypes.func,
    dropdownDisplayFormatter: PropTypes.func,
    validateInput: PropTypes.func,
    onError: PropTypes.func,
};

export default RpRangeAutocomplete;